import StoreSalesManagement from './StoreSalesManagement';

export default StoreSalesManagement;
